import React from 'react'

const MaterialTestingServicesConcrete = () => {
  return (
    <section className="services-details pt-120 pb-120">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          {/*Start Services Details Content*/}
          <div className="col-xl-12 col-lg-12">
            <div className="services-details__content">
              <h3>Material Testing Services – Concrete </h3>
              <p className="mb-30">
                Concrete is one of the most widely used construction materials,
                and its performance directly affects the strength, durability,
                and service life of structures. Concrete Material Testing must
                verify that concrete used in construction meets the specified
                design strength, quality, and durability requirements.
              </p>
              <p className="mb-30">
                The need for standardized concrete testing arose from structural
                failures caused by improper mixed design, inadequate curing,
                poor workmanship, and non-compliance with specifications.
                International standards were developed to ensure consistent
                testing methods and reliable assessment of concrete properties
                throughout the construction process.
              </p>
              <p className="mb-30">
                Without proper concrete material testing, structures may suffer
                from reduced load-bearing capacity, cracking, durability issues,
                and premature deterioration.
              </p>
              <div className="content mt-40">
                <div className="text">
                  <h3 className="mb-4">Purpose and Engineering Importance</h3>
                  <p className="mb-30">
                    The primary purpose of concrete material testing is to
                    ensure quality control and compliance at all stages of
                    construction. This service enables project stakeholders to:
                  </p>
                  <ul className="project-list">
                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Verifying concrete compressive strength and consistency
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Ensuring conformity with approved mix designs
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Monitoring production and placement quality
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Confirming durability-related properties of hardened
                      concrete
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Reducing risks of structural deficiencies and rework
                    </li>
                  </ul>
                  <p className="mb-30">
                    From a project management and risk-control perspective,
                    concrete testing is essential to achieving safe, durable,
                    and cost-effective construction.
                  </p>
                </div>
              </div>
              <div className="service-nr-list">
                <h3 className="mb-5">Our Services </h3>
                <p className="mb-30">
                  Pak Arab Inspection LTD. CO Company provides comprehensive Concrete
                  Material Testing services to support residential, commercial,
                  industrial, and infrastructure projects. Our testing services
                  are conducted following internationally recognized standards
                  and project specifications.
                </p>
                <p className="mb-30">
                  Our experienced technicians and engineers ensure right
                  sampling, testing, and reporting to support informed
                  engineering decisions and regulatory compliance.
                </p>
              </div>
              <div className="service-nr-list">
                <h3 className="">Scope of Concrete Material Testing </h3>
                <h4 className="">
                  Our Concrete Material Testing services typically include:
                </h4>
                <div className="row">
                  <div className="col-lg-4">
                    <h5>Fresh Concrete Tests</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Slump Test.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Temperature Measurement.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Air Content Test.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Unit Weight (Density).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Sampling and Casting of
                        Test Specimens.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Hardened Concrete Tests</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Compressive Strength
                        Test.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Flexural Strength Test.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Splitting Tensile
                        Strength Test.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Density and Absorption
                        Tests.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Durability and Specialized Tests (as needed) </h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Water Permeability Test.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Rapid Chloride
                        Penetration Test (RCPT).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Core Sampling and Testing
                        of In-Situ Concrete.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Non-Destructive Testing
                        Coordination (If Applicable).
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MaterialTestingServicesConcrete